import React, { Fragment } from "react";
import MultiSelect from "components/Form/fields/MultiSelect";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import set from "lodash/set";
import { omitDeep } from "utils/data";
import { useMessagesError } from "utils/hooks/editor";
import classnames from "classnames";

const SHIPPING_EVERYWHERE = "You ship everywhere";
const SELECT_SHIPPING_DESTINATIONS = "Select countries you ship to";

const ShippingCountriesSelect = ({
  shippingWorldwideActive,
  selections,
  name,
  options
}) => {
  const { touched, setValues, setFieldTouched, values } = useFormikContext();
  const shippingCountriesPath = getFieldPath(
    name,
    "shipping_address_collection.allowed_countries"
  );
  const error = useMessagesError(
    STATE_KEYS.SHORT_LINK.SHIPPING_ALLOWED_COUNTRIES
  );
  const destinationsSelectProps = {
    value: shippingWorldwideActive ? [] : selections,
    placeholder: shippingWorldwideActive
      ? SHIPPING_EVERYWHERE
      : SELECT_SHIPPING_DESTINATIONS,
    options,
    disabled: shippingWorldwideActive,
    onChange: () => (updatedSelections) => {
      if (!get(touched, shippingCountriesPath)) {
        setFieldTouched(shippingCountriesPath, true);
      }
      const selectedCodes = updatedSelections
        ? updatedSelections.map((selection) => selection.value)
        : [];

      setTimeout(() => {
        const updatedValues = omitDeep(
          values,
          STATE_KEYS.SHORT_LINK.SHIPPING_WORLDWIDE
        );
        set(updatedValues, shippingCountriesPath, selectedCodes);

        setValues(updatedValues);
      }, 0);
    },
    labelTransform: (value) => value
  };

  return (
    <Fragment>
      <div className="flex flex-row justify-between items-center pt3 pb1">
        <label
          className={classnames("f6 fw5 db mb1", {
            "color-error": error
          })}
        >
          Countries
        </label>
      </div>
      <MultiSelect {...destinationsSelectProps} />
    </Fragment>
  );
};

export default ShippingCountriesSelect;
